import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgIconArrowDownThin = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 8 10",
	fill: "currentColor",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M3.559 9.191c.244.245.64.245.884 0l3.125-3.125a.626.626 0 0 0-.884-.884l-2.059 2.06V1.25a.624.624 0 1 0-1.25 0v5.99L1.316 5.184a.626.626 0 0 0-.884.884l3.125 3.125z" })
});
export default SvgIconArrowDownThin;
